import React from 'react';

const SideBar = (props) => {

return (
    <div className="awdp_content_right"> 
                <div className="awdp_settings">
                    <div className="awdp_messagebox">
                                    
                    </div> 
                    <div className="awdp_textbox">
                        <h4>24x7 Support</h4>
                        <p>Our support is what makes us No1. We are available round the clock for any support</p>
                        <a href="https://wordpress.org/support/plugin/aco-woo-dynamic-pricing/" target="_blank">Contact Support</a>
                    </div>
                    <div className="awdp_textbox">
                        <h4>Full Documentation</h4>
                        <p>Look for any helps in our documentation if you are stuck with anything</p>
                        <a href="https://wordpress.org/plugins/aco-woo-dynamic-pricing/" target="_blank">Read More</a>
                    </div>
                </div>
            </div>
);
}

export default SideBar;